import { camelCase } from "lodash";
import { LogModel } from ".";

export class Trip {
  public tripStartDate: Date = null;
  public tripEndDate: Date = null;
  public tripStartAddress: string = null;
  public tripEndAddress: string = null;
  public tripDistance: number = null;
  public items: LogModel[] = [];
  public vehicleId: number;

  constructor(obj?: any) {
    for (const field in obj) {
      const camelCasedField = camelCase(field);
      if (typeof this[camelCasedField] !== "undefined") {
        this[camelCasedField] = obj && obj[field];
      }
    }
  }
}
